import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import styles from "./Welcome.scss";
import MaterialIcon from "material-icons-react";
import Button from "material-ui/Button";
import Modal from "react-modal";
import axios from "axios";

const steps = {
  SCHEDULE_CALL: "SCHEDULE_CALL",
  SETUP_CHROMECAST: "SETUP_CHROMECAST",
  DOWNLOAD_DIGICAST: "DOWNLOAD_DIGICAST",
  INSTALL_DIGICAST: "INSTALL_DIGICAST",
  FINAL_STEP: "FINAL_STEP",
};

class Welcome extends Component {
  static propTypes = {
    user: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super(props);
    console.log("constructor called");

    // Default step is either the last visited or the default one based on the user's plan
    var currentStep = localStorage.getItem("currentStep");
    var previousSteps = [];
    if (!steps[currentStep]) {
      currentStep =
        props.user.plan == "tv" ? steps.SCHEDULE_CALL : steps.SETUP_CHROMECAST;
    } else {
      // Reconstruct steps history
      if (props.user.plan != "tv") {
        if (currentStep == steps.DOWNLOAD_DIGICAST)
          previousSteps = [steps.SCHEDULE_CALL, steps.SETUP_CHROMECAST];
        else if (currentStep == steps.INSTALL_DIGICAST)
          previousSteps = [
            steps.SCHEDULE_CALL,
            steps.SETUP_CHROMECAST,
            steps.DOWNLOAD_DIGICAST,
          ];
        else if (currentStep == steps.FINAL_STEP)
          previousSteps = [
            steps.SCHEDULE_CALL,
            steps.SETUP_CHROMECAST,
            steps.DOWNLOAD_DIGICAST,
            steps.INSTALL_DIGICAST,
          ];
      }
    }
    this.state = {
      previousSteps: previousSteps,
      currentStep: currentStep,
      needsCalendlyScript: currentStep == steps.SCHEDULE_CALL, //tv starts on the schedule call page
      categories: undefined,
      showCategories: false,
      arrayCategoriesClient: [],
      showbtnValide: false,
      showSuccess: false,
      showError: false,
      inLocalStorageCateg: false,
    };
    this.loadCalendlyScript();
    this.goToPreviousStep = this.goToPreviousStep.bind(this);
  }

  componentDidUpdate() {
    console.log("did update", this.state.currentStep);
    this.loadCalendlyScript();
    setTimeout(() => {
      let calendlyVisible =
        this.state.currentStep == steps.SCHEDULE_CALL ? "block" : "none";
      console.log("calendly", calendlyVisible);
      document.querySelectorAll("iframe").forEach((i) => {
        if ((i.getAttribute("src") || "").includes("calendly")) {
          i.style.display = calendlyVisible;
        }
      });
    }, 50);
  }

  componentDidMount() {
    if (localStorage.getItem("CategoriesAsking")) {
      this.setState({
        showSuccess: true,
        showError: false,
        showbtnValide: false,
        inLocalStorageCateg: true,
      });
    } else {
      this.getCategories();
    }
  }

  setCurrentStepTo(step) {
    localStorage.setItem("currentStep", step);
    this.setState({
      currentStep: step,
    });
  }

  getCategories = async () => {
    try {
      var data = {
        userId: this.props.user.id,
        specialityId: this.props.user.specialityId,
      };
      var res = await axios.get(
        `https://app.digidocteur.com/api/Categories/getCategories?specialityId=${data.specialityId}&userId=${data.userId}`
      );
      if (!res) {
        this.setState({
          categories: res.data,
          showCategories: false,
        });
      }
      this.setState({
        categories: res.data,
        showCategories: true,
      });
    } catch (error) {
      console.log("Err modal resquest ", error);
    }
  };

  InsertCategoriesArrayClient = (e, categories) => {
    if (e.target.checked) {
      this.state.arrayCategoriesClient.push(categories);
      console.log(
        "Tableaux de toutes les catégories : ",
        this.state.arrayCategoriesClient
      );
    } else {
      var position = this.state.arrayCategoriesClient.indexOf(categories);
      this.state.arrayCategoriesClient.splice(position, 1);
      console.log("Remove tab : ", this.state.arrayCategoriesClient);
    }
    if (this.state.arrayCategoriesClient.length > 0) {
      this.setState({
        showbtnValide: true,
      });
    } else {
      this.setState({
        showbtnValide: false,
      });
    }
  };

  SendMailFormToPlaylist = async (e) => {
    try {
      e.preventDefault();
      var data = {
        nameClient: this.props.user.lastName + " " + this.props.user.firstName,
        emailClient: this.props.user.email,
        subdomainClient: this.props.user.subdomain,
        categories: this.state.arrayCategoriesClient,
        to: "samuel.morales.llb@gmail.com",
      };
      var res = await axios.post(
        "https://vcloud-email.herokuapp.com/api/v1/emailCategoriesDigidocteur/",
        data
      );
      if (res.data == "SUCCESS") {
        this.setState({
          showSuccess: true,
          showError: false,
          showbtnValide: false,
        });
        localStorage.setItem("CategoriesAsking", "true");
      } else {
        this.setState({
          showSuccess: false,
          showError: true,
          showbtnValide: false,
        });
      }
      console.log("Les data qui vont être envoyé dans le mail : ", data);
    } catch (error) {
      console.log("Err modal resquest ", error);
    }
  };

  goTo(step) {
    if (this.state.currentStep == steps.SCHEDULE_CALL) {
      var el = document.querySelector(
        'div[data-identifier="welcome-steps-container"] iframe'
      );
      if (el) el.style.display = "none";
    }
    if (step == steps.SCHEDULE_CALL) {
      var el = document.querySelector(
        'div[data-identifier="welcome-steps-container"] iframe'
      );
      if (el) el.style.display = "block";
      this.setState({
        needsCalendlyScript: true,
      });
    }
    if (step == steps.FINAL_STEP) {
      localStorage.setItem("WELCOME_LAST_STEP_REACHED", true);
    }
    var previousSteps = [...this.state.previousSteps, this.state.currentStep];
    this.setState({
      previousSteps: previousSteps,
    });
    this.setCurrentStepTo(step);
  }

  goToPreviousStep() {
    var previousSteps = [...this.state.previousSteps];
    var previousStep = previousSteps.pop();
    this.setState({
      previousSteps: previousSteps,
    });
    this.setCurrentStepTo(previousStep);
  }

  loadCalendlyScript() {
    if (
      this.state.needsCalendlyScript &&
      !document.getElementById("calendly-script")
    ) {
      console.log("load calendly script");
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      script.id = "calendly-script";
      document.body.appendChild(script);
    }
  }

  renderCalendly() {
    console.log("I've rendered Calendly");
    return (
      <div className={styles.outerContainer}>
        <div className={styles.calendlyContainer}>
          <div className={styles.body}>
            <div
              className="calendly-inline-widget"
              data-url="https://calendly.com/digidocteur?primary_color=2196f3"
              style={{
                minWidth: "320px",
                height: "660px",
                background: "white",
              }}
            ></div>
          </div>
        </div>
        <div className={styles.buttonsContainer}>
          <Button
            variant="raised"
            color="primary"
            className={styles.prevButton}
            onClick={() => {
              this.goTo(steps.FINAL_STEP);
            }}
          >
            J'ai pris rendez-vous
          </Button>
          {!!this.state.previousSteps.length && (
            <Button
              variant="flat"
              color="secondary"
              className={styles.nextButton}
              onClick={this.goToPreviousStep}
            >
              Retour
            </Button>
          )}
          <a
            className={styles.closeWelcome}
            href="#"
            onClick={() => {
              this.goTo(steps.FINAL_STEP);
            }}
          >
            Fermer le guide d'installation
          </a>
        </div>
      </div>
    );
  }

  renderChromecastSetup() {
    return (
      <div className={styles.outerContainer}>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.headerLeftBlock}>
              <h3>Configurons ensemble votre TV</h3>
              <p>
                Digidocteur diffuse les vidéos médicales depuis l'ordinateur de
                votre cabinet vers votre TV en salle d'attente <b>en WiFi</b>,
                de façon totalement transparente
              </p>
            </div>
            <div className={styles.headerRightBlock}>
              <MaterialIcon
                className={styles.floatingIcon}
                color="#2196F3"
                icon="cast"
                size={75}
              />
            </div>
          </div>
          <div className={styles.body}>
            <ul>
              <li>
                Si vous avez une "Smart TV" récente, compatible avec le
                protocole de diffusion à distance Chromecast, vous pouvez passer
                à l'étape suivante.
              </li>
              <li>
                Si vous avez une TV plus ancienne et vous avez déjà une clé USB
                Chromecast branchée dessus, passez également à l'étape suivante.
              </li>
              <li>
                Si vous n'avez pas de Smart TV ni de Chromecast, vous pouvez
                acquérir une clé Chromecast dans la{" "}
                <a
                  target="_blank"
                  href="https://store.google.com/fr/product/chromecast"
                >
                  boutique officielle Google
                </a>
                .
              </li>
              <li>
                Si vous souhaitez des conseils pour une installation de TV,
                envoyez un mail à l'adresse suivante contact@digidocteur.com ou
                téléphonez au
                <a
                  href="#"
                  onClick={() => {
                    this.goTo(steps.SCHEDULE_CALL);
                  }}
                >
                  06 51 52 66 22
                </a>
                .
              </li>
              <li>
                Les vidéos sont disponibles sur une application mobile pour vos
                patients. Si vous ne souhaitez pas de TV, un poster avec un QR
                code est suffisant. Contactez nous par mail pour son envoi :
                contact@digidocteur.com
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.buttonsContainer}>
          <Button
            variant="raised"
            color="primary"
            className={styles.prevButton}
            onClick={() => {
              this.goTo(steps.DOWNLOAD_DIGICAST);
            }}
          >
            Étape suivante
          </Button>
          <a
            className={styles.closeWelcome}
            href="#"
            onClick={() => {
              this.goTo(steps.FINAL_STEP);
            }}
          >
            Fermer le guide d'installation
          </a>
        </div>
      </div>
    );
  }

  renderDownloadDigicast() {
    return (
      <div className={styles.outerContainer}>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.headerLeftBlock}>
              <h3>Votre TV est prête ?</h3>
              <p>
                Passons à l'installation de l'application <b>Digicast</b> qui
                permet de diffuser les vidéos médicales sur votre TV.
              </p>
            </div>
            <div className={styles.headerRightBlock}>
              <MaterialIcon
                className={styles.floatingIcon}
                color="#2196F3"
                icon="cast"
                size={75}
              />
            </div>
          </div>
          <div className={styles.body}>
            <ul>
              <li>
                L'ordinateur sur lequel Digicast est installé doit rester allumé
                pour pouvoir diffuser les vidéos sur votre TV.
              </li>
              <li>
                Si vous avez une assistante médicale, nous vous conseillons
                d'installer Digicast sur son ordinateur, qui reste normalement
                allumé toute la journée.
              </li>
              <li>
                <a href="https://digidocteur.s3.eu-central-1.amazonaws.com/digicast/digidocteur-win-1.1.4s.exe">
                  Cliquez ici pour télécharger Digicast pour Windows
                </a>
                . &nbsp;
                <MaterialIcon
                  className={styles.floatingIcon}
                  color="#2196F3"
                  icon="desktop_windows"
                  size={25}
                />
              </li>
              <li>
                <a href="https://digidocteur.s3.eu-central-1.amazonaws.com/digicast/digidocteur-mac-1.1.4.dmg">
                  Cliquez ici pour télécharger Digicast pour Mac
                </a>
                . &nbsp;
                <MaterialIcon
                  className={styles.floatingIcon}
                  color="#2196F3"
                  icon="desktop_mac"
                  size={25}
                />
              </li>
              <li>
                Si vous souhaitez de l'assistance pour Digicast,
                <a
                  href="#"
                  onClick={() => {
                    this.goTo(steps.SCHEDULE_CALL);
                  }}
                >
                  {" "}
                  cliquez ici
                </a>
                .
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.buttonsContainer}>
          <Button
            variant="raised"
            color="primary"
            className={styles.prevButton}
            onClick={() => {
              this.goTo(steps.INSTALL_DIGICAST);
            }}
          >
            Étape suivante
          </Button>
          {!!this.state.previousSteps.length && (
            <Button
              variant="flat"
              color="secondary"
              className={styles.nextButton}
              onClick={this.goToPreviousStep}
            >
              Retour
            </Button>
          )}
          <a
            className={styles.closeWelcome}
            href="#"
            onClick={() => {
              this.goTo(steps.FINAL_STEP);
            }}
          >
            Fermer le guide d'installation
          </a>
        </div>
      </div>
    );
  }

  renderInstallDigicast() {
    return (
      <div className={styles.outerContainer}>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.headerLeftBlock}>
              <h3>Installons Digicast</h3>
              <p>
                Si vous avez bien téléchargé Digicast sur votre la machine qui
                servira à la diffusion des vidéos, nous pouvons procéder.
              </p>
            </div>
            <div className={styles.headerRightBlock}>
              <MaterialIcon
                className={styles.floatingIcon}
                color="#2196F3"
                icon="cast"
                size={75}
              />
            </div>
          </div>
          <div className={styles.body}>
            <ul>
              <li>Cliquez sur l'installeur téléchargé. Digicast s'installe.</li>
              <li>
                Si votre pare-feu vous bloque, autorisez les droits d'accès au
                réseau.
              </li>
              <li>
                Connectez-vous avec votre identifiant et votre mot de passe
                Digidocteur.
              </li>
              <li>
                Choisissez une Chromecast ou une Smart TV sur votre réseau et
                démarrez la diffusion.
              </li>
              <li>
                Vous pouvez modifier les vidéos diffusées depuis cette interface
                en ligne.
              </li>
              <li>
                Si vous souhaitez de l'assistance pour Digicast,
                <a
                  href="#"
                  onClick={() => {
                    this.goTo(steps.SCHEDULE_CALL);
                  }}
                >
                  {" "}
                  cliquez ici
                </a>
                .
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.buttonsContainer}>
          <Button
            variant="raised"
            color="primary"
            className={styles.prevButton}
            onClick={() => {
              this.goTo(steps.FINAL_STEP);
            }}
          >
            Tout fonctionne !
          </Button>
          {!!this.state.previousSteps.length && (
            <Button
              variant="flat"
              color="secondary"
              className={styles.nextButton}
              onClick={this.goToPreviousStep}
            >
              Retour
            </Button>
          )}
          <a
            className={styles.closeWelcome}
            href="#"
            onClick={() => {
              this.goTo(steps.FINAL_STEP);
            }}
          >
            Fermer le guide d'installation
          </a>
        </div>
      </div>
    );
  }

  renderPendingVideos() {
    if (this.props.user.videoGenerateStatus == "pending") {
      return (
        <div className={styles.generatingVideosText}>
          <img
            className={styles.imgRecord}
            src="assets/img/DD-logo-long-noir.png"
          />
          <h1 className={styles.titleMovie}>Nous y sommes presque !</h1>

          <p>
            Des petites mains agiles fabriquent des vidéos sur mesure avec votre
            nom et les coordonnées de votre cabinet, pour le plus grand plaisir
            de vos patients.
          </p>
          <p>
            La création des vidéos prend environ 24 heures, parfois moins. Vous
            recevrez un email quand ce sera fini.
          </p>
          <br />
          <p className={styles.btnMarginBtn}>
            <a href="mailto:contact@digidocteur.com">
              Un problème ? Contactez-nous : contact@digidocteur.com Téléphone :
              06 51 52 66 22
            </a>
          </p>
          <a
            href="#"
            onClick={() => {
              this.goTo(steps.SETUP_CHROMECAST);
            }}
            className={styles.btnTutorial}
          >
            Voir l'installation
          </a>
          {/* <a href="#" onClick={() => { this.setState({ ModalIsOpen: true }) }} className={styles.btnTutorialForm}>Obtenir votre playlist</a> */}
          <br></br>
          <div className={styles.obj_loader}></div>
          <Modal isOpen={this.state.ModalIsOpen}>
            <a
              onClick={() => {
                this.setState({ ModalIsOpen: false });
              }}
            >
              <p className={styles.btnCloseModal}>x</p>
            </a>
            <img
              className={styles.LogoDdModal}
              src="assets/img/DD-logo-long-noir.png"
            />
            <h2 className={styles.titleModal}>
              Configurez votre playlist personnelle
            </h2>
            <p className={styles.underTitleModal}>
              Vous pouvez d'ores et déjà choissir les catégories de vidéo pour
              votre playlist personnelle.
            </p>
            <div className={styles.containerCategModal}>
              {this.state.showCategories &&
                this.state.categories &&
                this.state.categories.map((categorie) => (
                  <label className={styles.option_item}>
                    <input
                      type="checkbox"
                      className={styles.checkbox}
                      onClick={(e) =>
                        this.InsertCategoriesArrayClient(e, categorie.name)
                      }
                    />
                    <div className={styles.option_inner}>
                      <div className={styles.tickmark}></div>
                      {/* <div className={styles.icon}></div> */}
                      <div className={styles.name}>{categorie.name}</div>
                    </div>
                  </label>
                ))}
              {!this.state.showCategories && !this.state.inLocalStorageCateg && (
                <div>
                  <p>
                    Si le chargement persiste veuilliez nous contacter{" "}
                    <a
                      className={styles.emailContactSupport}
                      href="mailto:support@digidocteur.com"
                    >
                      support@digidocteur.com
                    </a>
                  </p>
                  <div
                    id={styles.LoaderModal}
                    className={styles.obj_loader}
                  ></div>
                </div>
              )}
            </div>
            {this.state.showbtnValide &&
              !this.state.showSuccess &&
              !this.state.showError &&
              !this.state.inLocalStorageCateg && (
                <button
                  className={styles.btnConfirmFormCateg}
                  onClick={(e) => this.SendMailFormToPlaylist(e)}
                >
                  Valider
                </button>
              )}
            {!this.state.showbtnValide &&
              this.state.showSuccess &&
              !this.state.showError && (
                <p className={styles.successMessage}>
                  Nous avons bien reçu votre demande ✔️
                </p>
              )}
            {!this.state.showbtnValide && this.state.showError && (
              <p className={styles.errorMessage}>
                Un problème est survenu avec l'envoi de formulaire. Vous pouvez
                le remplir à nouveau en rechargeant la page ou nous envoyer vos
                préférences de vidéos sur contact@digidocteur.com ❌
              </p>
            )}
          </Modal>
        </div>
      );
    } else {
      return "";
    }
  }

  renderReadyToGo() {
    return <div>Vous êtes prêts à démarrer !</div>;
  }

  render() {
    const { user } = this.props;
    let stepContent = "";
    switch (this.state.currentStep) {
      // if step == SCHEDULE CALL, show a calendly embed
      case steps.SCHEDULE_CALL:
        stepContent = this.renderCalendly();
        break;

      // if step == SETUP CHROMECAST, show a chromecast icon and instructions
      case steps.SETUP_CHROMECAST:
        stepContent = this.renderChromecastSetup();
        break;

      // if step == DOWNLOAD DIGICAST, show a download button to S3
      case steps.DOWNLOAD_DIGICAST:
        stepContent = this.renderDownloadDigicast();
        break;

      // if step == INSTALL_DIGICAST, show installation instructions
      case steps.INSTALL_DIGICAST:
        stepContent = this.renderInstallDigicast();
        break;

      // final_step
      case steps.FINAL_STEP:
        if (user.videoGenerateStatus == "pending") {
          // if videoGenerateStatus == pending : show the pending video screen
          stepContent = this.renderPendingVideos();
        } else {
          // final_step and videoGenerateStatus != pending : show a "start" button
          stepContent = this.renderReadyToGo();
        }
        break;
    }

    return (
      <Fragment>
        <div data-identifier="welcome-steps-container">{stepContent}</div>
      </Fragment>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/pages/admin/Welcome.jsx